import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "react-query";
import { useAppDispatch } from "../../hooks/hooks";
import { key_Scholarships } from "../../utils/constants";
import toast from "react-hot-toast";
import { routes } from "../../routes";
import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { ConfirmAlertDialog } from "../../components/common/ConfirmAlertDialog";
import { updateScholarship } from "../../services/school/scholarship";
import { setScholarshipData } from "../../redux/slices/school/scholarship";
import { ScholarshipType } from "../../types/Scholarship";
import { useGetScholarshipsQuery } from "../../hooks/useGetScholarshipsQuery";
import { getStudentByCode, getStudentById } from "../../services/school/student/getStudentByCode";
import { getUserById } from "../../services/user/getUsers";
import { resetStudentData, setStudentData } from "../../redux/slices/school/student";
import { resetUserData, setUserData } from "../../redux/slices/users/user";
import { isEmpty } from "lodash";

const columnNamesMap: { [key: string]: string } = {
    studentCode: "Código do Estudante",
    fullname: "Nome do Estudante",
    scholarshipProvider: "Provedor",
    scholarshipType: "Tipo de Bolsa",
    percent: "Percentual (%)",
};

export const Scholarships = () => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [itemToBeDeleted, setItemToBeDeleted] = useState<ScholarshipType | null>(null);

    const queryClient = useQueryClient();
    const dispatch = useAppDispatch();
    const { data, status } = useGetScholarshipsQuery({ PageNumber: currentPage, PageSize: 400 });

    const mutationUpdate = useMutation(updateScholarship, {
        onSuccess: () => {
            queryClient.invalidateQueries(key_Scholarships);
            toast.success("Bolsa de estudo removida!");
        },
        onError: () => {
            toast.error("Erro ao apagar Bolsa de estudo.");
        }
    });

    const handleCreate = () => {
        navigate(routes.createScholarship);
    };

    const handleEdit = async (s: ScholarshipType) => {
      if(isEmpty(s.idPaymentType)){
        s.idPaymentType =undefined;
      }
      if(isEmpty(s.idsPaymentTypes)){
        s.idsPaymentTypes = undefined;
      }else{
        try {
            const ids = JSON.parse(s.idsPaymentTypes || "[]") as { idPaymentType: string; percent: number }[] || [];
          s.idPaymentsPercents = ids ;
        } catch (error) {
         // toast.error("Erro ao processar tipos de pagamento.");
        }
      }
        dispatch(setScholarshipData(s));
        try {
          const studentData = await getStudentById(s.idStudent);
          if (!studentData) return;
          const userData = await getUserById(studentData?.idUser);
          dispatch(setStudentData(studentData));
          dispatch(setUserData(userData));
        } catch {
          dispatch(resetStudentData());
          dispatch(resetUserData());
        }
        navigate(routes.updateScholarship);
    };

    const handleDelete = (s: ScholarshipType) => {
      try {
        s.status = false;
        mutationUpdate.mutateAsync(s);
      } catch (error) {
        toast.error("Erro ao apagar Bolsa de estudo.");
      }
     
    };

    const openDeleteDialog = (s: ScholarshipType) => {
        setItemToBeDeleted(s);
    };

    const confirmDelete = () => {
        if (itemToBeDeleted) {
            handleDelete(itemToBeDeleted);
        }
    };

    const options = data?.items.map((item) => [
        {
            label: "Editar",
            onClick: () => handleEdit(item),
            icon: <Pencil1Icon />
        },
        {
            label: "Eliminar",
            onClick: () => openDeleteDialog(item),
            icon: <TrashIcon />
        },
    ]) || [];

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    return (
        <>
            <Lists
                status={status}
                TableComponent={() => (
                    <TableComponent
                        columns={Object.keys(columnNamesMap)}
                        items={data?.items}
                        options={options}
                        columnNamesMap={columnNamesMap}
                        totalPages={data?.totalPages || 1}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                    />
                )}
                handleClickCreate={handleCreate}
            />
            <ConfirmAlertDialog
                open={!!itemToBeDeleted}
                onOpenChange={(open) => !open && setItemToBeDeleted(null)}
                title="Esta operação é irreversível"
                item={itemToBeDeleted}
                onConfirm={confirmDelete}
                onCancel={() => setItemToBeDeleted(null)}
            />
        </>
    );
};
